import axios from '@/api/client';

const state = {
  unknowns: [],
  unknown: null,
  trainingStats: null,
};

const getters = {
  stateUnknowns: state => state.unknowns,
  stateUnknown: state => state.unknown,
  stateTrainingStats: state => state.trainingStats,
};

const actions = {
  async getUnknowns({ commit }, payload = {}) {
    try {
      const response = await axios.get('unknowns', {
        params: {
          anzahl_Bilder: payload.anzahl_Bilder ?? 20
        }
      });

      const data = response?.data ?? [];

      console.log('<-<-<-<-<>>>getUnknowns:', data);

      commit('setUnknowns', Array.isArray(data) ? data : []);
      return data;
    } catch (error) {
      console.error('getUnknowns failed:', error);
      commit('setUnknowns', []);
      return [];
    }
  },

  async getTrainingStats({ commit }) {
    try {
      const response = await axios.get('trainingStats');
      const data = response?.data ?? null;

      console.log('<-<-<-<-<>>>getTrainingStats:', data);

      commit('setTrainingStats', data);
      return data;
    } catch (error) {
      console.error('getTrainingStats failed:', error);
      commit('setTrainingStats', null);
      return null;
    }
  },

  async tagfaces({ dispatch }, payload) {
    try {
      console.log('<-<-<-<-<>>>tagfaces payload:', payload);

      const response = await axios.post('tagfaces', payload);
      const data = response?.data ?? null;

      console.log('<-<-<-<-<>>>tagfaces response:', data);

      await dispatch('getUnknowns', {
        anzahl_Bilder: payload.anzahl_Bilder ?? 20
      });

      await dispatch('getTrainingStats');

      return data;
    } catch (error) {
      console.error('tagfaces failed:', error);
      throw error;
    }
  },
};

const mutations = {
  setUnknowns(state, unknowns) {
    state.unknowns = Array.isArray(unknowns) ? unknowns : [];
  },
  setUnknown(state, unknown) {
    state.unknown = unknown;
  },
  setTrainingStats(state, trainingStats) {
    state.trainingStats = trainingStats;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};